import quickViewPdp from './product/quickViewPdp';
var processInclude = require('base/util');
import sizeGuide from './product/sizeGuide';

// eslint-disable-next-line no-undef
$(document).ready(function () {
    processInclude(quickViewPdp);
    processInclude(sizeGuide);
});